// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__bx770","icon":"styles_icon__2EAGA"};